export default __webpack_public_path__ + "static/media/G0004.087873c3.png";